<template>
  <div class="popup-wraper" @click.stop="onHideModal">
    <div class="popup-overlay" @click.stop>
      <div class="popup-overlay-title">
        <img alt="img" src="@/assets/img/crop.svg" />
        <span class="popup-overlay-title-span">crop</span>
      </div>
      <div class="popup-scroll">
        <cropper
          classname="cropper"
          backgroundClassname="bg-copper"
          areaClassnam="area-copper"
          :src="img"
          @change="changeImg"
        ></cropper>
      </div>
      <button
        class="popup-btn"
        :data-is-avalable="popupsVisible"
        id="apply-btn"
        @click="saveChangesOnCanvas"
      >
        apply
      </button>
      <div class="popup-close" @click="onHideModal">&times;</div>
    </div>
  </div>
</template>

<script>
import { fabric } from "fabric";
import { mapGetters } from "vuex";
import { Cropper } from "vue-advanced-cropper";
import nameCanvasObject from "@/util/canvas/nameCanvasObject";
import "@/assets/css/popups.css";

export default {
  name: "crop",
  components: {
    Cropper
  },
  computed: {
    ...mapGetters({
      canvas: "workSpace/canvas",
      activeCanvasObject: "workSpace/activeCanvasObject",
      popupsVisible: "workSpace/popupsVisible"
    })
  },
  mounted() {
    const type = this.activeCanvasObject.name;
    if (type === "img") {
      this.img = this.activeCanvasObject.getSrc();
    }
  },
  data() {
    return {
      lastActive: null,
      disabled: false,
      img: "",
      newImg: ""
    };
  },
  methods: {
    onHideModal() {
      this.$emit("hide-modal");
    },
    changeImg({ coordinates, canvas }) {
      this.coordinates = coordinates;
      if (this.activeCanvasObject.name === "img")
        this.newImg = canvas.toDataURL();
    },
    saveChangesOnCanvas() {
      const active = this.activeCanvasObject;
      const params = {
        top: active.get("top") < 0 ? 0 : active.get("top"),
        left: active.get("left") < 0 ? 0 : active.get("left")
      };
      if (this.activeCanvasObject.name === "img") {
        this.canvas.remove(active);
        fabric.Image.fromURL(this.newImg, imgInstance => {
          imgInstance.set(params);
          nameCanvasObject(imgInstance, "img");
          this.canvas.add(imgInstance).setActiveObject(imgInstance);
        });
      }
      this.onHideModal();
    }
  }
};
</script>

<style scoped>
.popup-scroll {
  min-height: calc(100% - 130px);
}
.cropper {
  height: 100%;
  max-width: calc(100% - 20px);
  min-height: 200px;
}
.cropper >>> .vue-square-handler {
  background: #ff0;
  border-radius: 50%;
}
.cropper >>> .bg-copper {
  background-image: url(../../assets/img/qr/card_bg.png);
}
</style>
